import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "OpenClosePanel.svg",
  "use": "OpenClosePanel.svg-usage",
  "viewBox": "0 0 10 40",
  "content": "<symbol viewBox=\"0 0 10 40\" xmlns=\"http://www.w3.org/2000/svg\" id=\"OpenClosePanel.svg\">\n<path d=\"M5.90359 1.56614C5.70024 0.651066 4.88861 0 3.95121 0H2C0.89543 0 0 0.895431 0 2V38C0 39.1046 0.89543 40 2 40H3.95121C4.88861 40 5.70024 39.3489 5.90359 38.4339L8.45738 26.9418C9.4734 22.3697 9.4734 17.6303 8.45738 13.0582L5.90359 1.56614Z\" fill=\"#101820\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol